import 'react-app-polyfill/ie9';
import 'util/call-api';
import 'util/utils';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import Root from './config/Root';
import { store } from './redux/store';

import 'styles/main.less';

ReactDOM.render(
  <Provider store={store}>
    <Root />
  </Provider>,
  document.getElementById('root'),
);
